const translation = {
  title: 'Khám phá',
  sidebar: {
    discovery: 'Khám phá',
    chat: 'Trò chuyện',
    workspace: 'Không gian làm việc',
    action: {
      pin: 'Ghim',
      unpin: 'Bỏ ghim',
      rename: 'Đổi tên',
      delete: 'Xóa',
    },
    delete: {
      title: 'Xóa ứng dụng',
      content: 'Bạn có chắc chắn muốn xóa ứng dụng này không?',
    },
  },
  apps: {
    title: 'Khám phá ứng dụng bởi Dify',
    description: 'Sử dụng ngay các ứng dụng mẫu này hoặc tùy chỉnh ứng dụng của bạn dựa trên các mẫu có sẵn.',
    allCategories: 'Tất cả danh mục',
  },
  appCard: {
    addToWorkspace: 'Thêm vào không gian làm việc',
    customize: 'Tùy chỉnh',
  },
  appCustomize: {
    title: 'Tạo ứng dụng từ {{name}}',
    subTitle: 'Biểu tượng và tên ứng dụng',
    nameRequired: 'Vui lòng nhập tên ứng dụng',
  },
  category: {
    Assistant: 'Trợ lý',
    Writing: 'Viết lách',
    Translate: 'Dịch thuật',
    Programming: 'Lập trình',
    HR: 'Nhân sự',
    Agent: 'Người đại lý',
    Workflow: 'Quy trình làm việc',
    Entertainment: 'Giải trí',
  },
}

export default translation
